import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'secondsToHhMm',
    standalone: true
})
export class SecondsToHhMmPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);

    const parts = [];
    if (hours > 0) {
      parts.push(`${hours}h`);
    }
    if (minutes > 0 || hours === 0) {
      parts.push(`${minutes}min`);
    }
    return parts.join(' ');
  }
}
